import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { merge } from "lodash";
import React, { useEffect, useState } from "react";

import { SimpleSnackbarProvider } from "./components/SimpleSnackbar";
import defaultTheme from "./theme/materialTheme";

const queryClient = new QueryClient();

const persister = createAsyncStoragePersister({
  storage: window.localStorage,
});

const Provider = ({ children }) => {
  const [theme, setTheme] = useState(createTheme(defaultTheme));

  const handleMessage = async ({ data: event }) => {
    if (event.data?.theme) {
      const newTheme = merge({}, theme, event.data?.theme);
      setTheme(createTheme(newTheme));
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ persister }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SimpleSnackbarProvider>{children}</SimpleSnackbarProvider>
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen />
    </PersistQueryClientProvider>
  );
};

export default Provider;
